module.exports = __webpack_public_path__ + "img/Informacion.8f90e30c.png";